// <!-- 卓学云后台管理系统 -->
// <!-- 卓学云直播授课系统 -->
// 管理端 '1' 或者 教师上课直播端 '2'
// 2||
window.sysType = location.origin.indexOf('teacher') > -1 ? 2 : 1;
document.title =
  window.sysType == 2 ? '卓学云直播授课系统' : '卓学云后台管理系统';

